import { render, staticRenderFns } from "./DashBoardCallFilters.vue?vue&type=template&id=485676be"
import script from "./DashBoardCallFilters.vue?vue&type=script&lang=js"
export * from "./DashBoardCallFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports